var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1563_21954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3752 10.54C36.5467 7.69348 32.9368 5.75087 29.0031 4.9584C25.0693 4.16593 20.9888 4.55929 17.2789 6.08862C13.5689 7.61794 10.3966 10.2144 8.16402 13.5487C5.93144 16.8831 4.73915 20.8053 4.73828 24.8181V35.3181C4.73828 36.7105 5.2914 38.0458 6.27597 39.0304C7.26054 40.015 8.59589 40.5681 9.98828 40.5681H12.9883C14.3807 40.5681 15.716 40.015 16.7006 39.0304C17.6852 38.0458 18.2383 36.7105 18.2383 35.3181V27.8181C18.2383 26.4257 17.6852 25.0904 16.7006 24.1058C15.716 23.1212 14.3807 22.5681 12.9883 22.5681H9.39578C9.93878 18.8197 11.8136 15.3923 14.677 12.9132C17.5403 10.4341 21.2008 9.06907 24.9883 9.06809H25.1083C28.8789 9.08424 32.5177 10.4574 35.3589 12.9364C38.2001 15.4154 40.0537 18.8345 40.5808 22.5681H36.9883C35.5959 22.5681 34.2605 23.1212 33.276 24.1058C32.2914 25.0904 31.7383 26.4257 31.7383 27.8181V35.3181C31.7383 36.7105 32.2914 38.0458 33.276 39.0304C34.2605 40.015 35.5959 40.5681 36.9883 40.5681H40.6633C40.4904 41.4151 40.0301 42.1764 39.3605 42.7231C38.6908 43.2698 37.8528 43.5683 36.9883 43.5681H26.4883C25.8915 43.5681 25.3192 43.8051 24.8973 44.2271C24.4753 44.6491 24.2383 45.2214 24.2383 45.8181C24.2383 46.4148 24.4753 46.9871 24.8973 47.4091C25.3192 47.831 25.8915 48.0681 26.4883 48.0681H36.9883C39.1756 48.0656 41.2725 47.1956 42.8192 45.649C44.3658 44.1023 45.2358 42.0054 45.2383 39.8181V24.8181C45.2486 22.1694 44.736 19.5448 43.7299 17.0946C42.7237 14.6445 41.2439 12.417 39.3752 10.54ZM12.9883 27.0681C13.1872 27.0681 13.378 27.1471 13.5186 27.2878C13.6593 27.4284 13.7383 27.6192 13.7383 27.8181V35.3181C13.7383 35.517 13.6593 35.7078 13.5186 35.8484C13.378 35.9891 13.1872 36.0681 12.9883 36.0681H9.98828C9.78937 36.0681 9.5986 35.9891 9.45795 35.8484C9.3173 35.7078 9.23828 35.517 9.23828 35.3181V27.0681H12.9883ZM36.2383 35.3181V27.8181C36.2383 27.6192 36.3173 27.4284 36.458 27.2878C36.5986 27.1471 36.7894 27.0681 36.9883 27.0681H40.7383V36.0681H36.9883C36.7894 36.0681 36.5986 35.9891 36.458 35.8484C36.3173 35.7078 36.2383 35.517 36.2383 35.3181Z",
    fill: "url(#paint0_linear_1563_21954)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1563_21954",
    x1: 24.9884,
    y1: 4.55933,
    x2: 24.9884,
    y2: 48.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1563_21954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.988281 0.818115)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/Headset.cbb7bc946b3f1271036bc122e9704fdb.svg";
export { ForwardRef as ReactComponent };